import { useState } from "react";
import { Link } from "react-router-dom";
import { supabase } from "@/lib/supabaseClient";
import { Input } from "@/components/ui/input";
import Button from "@/components/ui/AppButton";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { allowedDomains } from "@/lib/allowedDomains";

export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setMessage("");

    const domain = email.split("@")[1];
    if (!allowedDomains.includes(domain)) {
      setMessage("Adresse e-mail non autorisée.");
      return;
    }

    setLoading(true);
    const { error } = await supabase.auth.signInWithOtp({
      email,
      options: {
        shouldCreateUser: false,
        emailRedirectTo: `${window.location.origin}/kanban`,
      },
    });

    if (error) {
      setMessage("Erreur : " + error.message);
    } else {
      setMessage("Un lien magique vous a été envoyé par e-mail !");
    }
    setLoading(false);
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-[#fdfcfb] to-[#e2d1c3]">
      <Card className="w-[400px] shadow-xl border-none">
        <CardHeader>
          <CardTitle className="text-center text-2xl font-semibold text-gray-800">
            Connexion Smile Event
          </CardTitle>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleLogin} className="space-y-4">
            <Input
              type="email"
              placeholder="Votre adresse e-mail professionnelle"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <Button
              type="submit"
              disabled={loading}
              className="w-full bg-indigo-600 text-white hover:bg-indigo-700"
            >
              {loading ? "Envoi en cours..." : "Recevoir le lien magique"}
            </Button>
          </form>
          {message && (
            <p className="mt-4 text-center text-sm text-gray-600">{message}</p>
          )}
          <p className="mt-4 text-center text-sm text-gray-500">
            <Link to="/login-pass" className="font-medium text-indigo-600 hover:text-indigo-700">
              Se connecter avec un mot de passe
            </Link>
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
